// Section spec for the help-site sidebar.
//
// Pages opt into a section through their frontmatter `nav.section`; this file
// only defines the sections themselves and the order they appear in. It is
// kept free of MDX imports so the build-time scripts (sitemap generator,
// content validation) can import it directly from plain Node.

export interface NavSectionSpec {
  /** Stable id referenced by each page's frontmatter `nav.section`. */
  id: string
  /** Display title shown as the sidebar group heading. */
  title: string
  /** Order of this section in the sidebar. Lower numbers come first. */
  order: number
}

export const navSections: NavSectionSpec[] = [
  { id: 'getting-started', title: 'Get started', order: 1 },
  { id: 'guides', title: 'Guides', order: 2 },
  { id: 'choosie', title: 'Choosie assistant', order: 3 },
  { id: 'workflows', title: 'Workflows', order: 4 },
  { id: 'reference', title: 'Reference', order: 5 },
  { id: 'troubleshooting', title: 'Troubleshooting', order: 6 },
]
